import { Container, Point } from 'pixi.js';
import { Prev } from './Prev';
import { theme } from 'game/theme';
import { MonoBehavior } from 'game/core/monoBehavior';
import { Store } from 'game/store/gameStore';
import { ScrollContainer } from './ScrollContainer';

export enum DesignTabs {
    BACKS = 'backs',
    FRONTS = 'fronts',
    BACKGROUNDS = 'bgs',
}
export class DesignSection extends MonoBehavior {
    public stylePrevArray: Prev[] = [];
    public container: Container;
    public type: DesignTabs;
    private columns: number;
    private width: number;
    private height: number;
    private gap = 0;
    private radius: number;
    private stylesArray: string[];
    scrollContainer: ScrollContainer;
    isLoaded = false;

    constructor(type: DesignTabs) {
        super();
        this.scrollContainer = new ScrollContainer();

        this.container = new Container();
        this.scrollContainer.addContent(this.container);
        this.type = type;
        this.width = 0;
        this.height = 0;
        this.columns = 0;
        this.radius = 0;
        this.stylesArray = [];
    }
    setActive(active: boolean) {
        if (active && !this.isLoaded) this.renderContent();
        this.scrollContainer.setActive(active);
    }

    isSelected(imgFileName: string, type: DesignTabs) {
        switch (type) {
            case DesignTabs.BACKS:
                return Store.back === imgFileName;
            case DesignTabs.FRONTS:
                return Store.front === imgFileName;
            case DesignTabs.BACKGROUNDS:
                return Store.background === imgFileName;
        }
    }
    renderContent() {
        this.isLoaded = true;

        const start = new Point(-172, 36);

        switch (this.type) {
            case DesignTabs.BACKS:
                this.columns = 3;
                this.width = 105;
                this.height = 145;
                this.radius = 12;
                this.gap = 11;
                this.stylesArray = theme.backs;
                break;
            case DesignTabs.FRONTS:
                this.columns = 1;
                this.width = 336;
                this.height = 125;
                this.radius = 17;
                this.gap = 15;
                this.stylesArray = theme.fronts;
                break;
            case DesignTabs.BACKGROUNDS:
                this.columns = 2;
                this.width = 200 * 0.8;
                this.height = 121 * 0.8;
                this.radius = 15;
                this.gap = 15;
                this.stylesArray = theme.backgrounds;
                break;
        }
        this.stylesArray.forEach((style, index: number) => {
            const posx = start.x + (this.width + this.gap) * (index % this.columns);
            const posy = start.y + ((index - (index % this.columns)) / this.columns) * (this.height + this.gap);
            const stylePrev = new Prev(style, this.type, this.width, this.height, this.radius);
            stylePrev.container.position.set(posx, posy);

            if (this.isSelected(style, this.type)) {
                stylePrev.select();
            } else {
                stylePrev.uncheck();
                stylePrev.checkContainer.alpha = 0;
            }
            stylePrev.container.cursor = 'pointer';
            stylePrev.container.on('pointerup', (e: PointerEvent) => {
                const blockEvent = this.scrollContainer.onPointerUp(e);
                if (blockEvent) return;
                this.stylePrevArray.forEach((style) => {
                    style.chosenBorder.alpha = 0;
                    style.checkContainer.alpha = 0;
                    switch (this.type) {
                        case DesignTabs.BACKS:
                            style.regularBorder.alpha = 0;
                            break;
                        default:
                            style.regularBorder.alpha = 1;
                            break;
                    }
                });
                stylePrev.onClick();
            });

            this.container.addChild(stylePrev.container);
            this.stylePrevArray.push(stylePrev);
        });
    }
}
